// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"map-ruler","clipPath":"url(#clip0_543_3544)"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M15.8573 1.62988L22.2543 8.02694L7.86093 22.4203L1.46387 16.0233L15.8573 1.62988Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5.06208 12.4248L6.66429 14.027M12.2589 5.22852L13.8611 6.83072M8.66047 8.82617L11.0623 11.228M15.8573 1.62988L22.2543 8.02694L7.86093 22.4203L1.46387 16.0233L15.8573 1.62988Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MapRulerIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'map-ruler',
    ref,
    icon: element,
  },
));

MapRulerIcon.displayName = 'MapRulerIcon';

export default MapRulerIcon;
